import React, { useEffect, useState } from 'react';
import { fetchGet } from '../../api/common';
import { Profile } from '@par/shared/types/player';
import { Box } from '@mui/material';
import { UploadQuestions } from './UploadQuestions';

export const QuestionsSetup = () => {
  const [users, setUsers] = useState<Profile[]>();

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetchGet('/admin');
      if (res) {
        setUsers(res.users);
      }
    };
    fetchData();
  }, []);

  return (
    <Box>
      <UploadQuestions></UploadQuestions>
    </Box>
  );
};
